import React from 'react'

type Props = { progress?: number, bgColor?: string, progressColor?: string }
const ProgressBar:React.FC<Props> = ({ progress, bgColor = 'soft-green/90', progressColor = 'electric-green' }) => {
  return (
    <div className={`h-1.5 bg-${bgColor} block w-full relative rounded-md`}>
      <div
        className={`h-1.5 absolute bg-${progressColor} rounded-md bottom-0 w-full`}
        style={{ width: `${progress}%` }}
      />
    </div>
  )
}

export default ProgressBar
